import API from '..';
const ENTITY = 'panels-brands';

export const getItems = () => API.get(`/api/v1/${ENTITY}/`);
